import React from 'react';
import { ToggleWrapper } from './ToggleWrapper';
import { ToggledFeature } from './featureToggleService';

export function AutoAssignRolesToggleWrapper(
  props: {
    children: React.ReactNode;
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.AUTO_ASSIGN_ROLES}>
      {props.children}
    </ToggleWrapper>
  );
}
